import React, { useState } from "react";
import { MapPin, Phone, Clock, MessageCircle, Send } from "lucide-react";
import { waLink } from "@/config";
import { useSettings } from "@/context/SettingsContext";

export default function Contact() {
  const { settings } = useSettings();
  const [form, setForm] = useState({ name: "", message: "" });
  const send = (e) => {
    e.preventDefault();
    const msg = `Hi, I'm ${form.name || "a customer"}. ${form.message}`;
    window.open(waLink(msg), "_blank");
  };
  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 py-12">
      <div className="text-center mb-10">
        <p className="text-xs uppercase tracking-widest text-[#C2410C] font-semibold">Get in Touch</p>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-[#1F130B] mt-1">Contact Us</h1>
        <p className="text-sm text-[#6B5B52] mt-2">We'd love to help you order the finest Kashmiri dry fruits.</p>
      </div>

      <div className="grid lg:grid-cols-2 gap-8">
        <div className="space-y-4">
          {[
            [MapPin, "Visit Us", settings.address],
            [Phone, "Call Us", settings.phone],
            [MessageCircle, "WhatsApp", settings.whatsapp_number],
            [Clock, "Business Hours", settings.hours],
          ].map(([Icon, t, d]) => (
            <div key={t} className="flex gap-4 rounded-2xl bg-white border border-[#E7E0D6] p-5">
              <div className="h-11 w-11 shrink-0 rounded-full bg-[#FEF3C7] grid place-items-center text-[#9A3412]"><Icon size={20} /></div>
              <div>
                <p className="font-semibold text-[#1F130B]">{t}</p>
                <p className="text-sm text-[#6B5B52] mt-0.5">{d}</p>
              </div>
            </div>
          ))}
          <a href={waLink("Hi! I have a question about your dry fruits.")} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 rounded-2xl bg-[#25D366] text-white font-semibold py-4 hover:brightness-95">
            <MessageCircle size={20} /> Chat with us on WhatsApp
          </a>
        </div>

        <form onSubmit={send} className="rounded-2xl bg-white border border-[#E7E0D6] p-6">
          <h2 className="font-display text-xl font-bold text-[#1F130B] mb-4">Send us a message</h2>
          <div className="space-y-4">
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" data-testid="contact-name" className="w-full rounded-xl border border-[#E7E0D6] bg-[#FAF6F0] px-4 py-3 text-sm outline-none focus:border-[#C2410C]" />
            <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="How can we help you?" rows={5} data-testid="contact-message" className="w-full rounded-xl border border-[#E7E0D6] bg-[#FAF6F0] px-4 py-3 text-sm outline-none focus:border-[#C2410C] resize-none" />
            <button data-testid="contact-send" className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#C2410C] hover:bg-[#9A3412] text-white font-semibold py-3">
              <Send size={17} /> Send via WhatsApp
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
